import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
var ImagePreview = function (props) {
    return (_jsx(Box, { children: _jsx("img", { src: props.isImage ? props.image.url : props.image.imageURL, alt: props.image.filename }) }));
};
export default ImagePreview;
